<template>
	<div class="grid-flex-container px-4 py-4">
		<v-card v-if="qr">
			<v-card-title>Project Details</v-card-title>
			<v-row>
				<v-col>
					<qrcode-vue
						class="pa-4"
						:value="qrString"
						:size="size"
						level="H"
					></qrcode-vue>
				</v-col>
				<v-col>
					<v-text-field
						label="Project"
						v-model="qr.ProjectName"
						disabled
					>
					</v-text-field>
					<v-text-field
						label="Description"
						v-model="qr.ProjectDescription"
						disabled
					></v-text-field>
					<v-text-field
						label="URL"
						v-model="qr.WebsiteUrl"
						disabled
					></v-text-field>
					<v-text-field
						label="Project ID"
						v-model="qr.ProjectId"
						disabled
					></v-text-field>
					<v-btn color="primary" :href="apkFileUrl" download>
						<v-icon>mdi-download</v-icon>
						Download Iris Mobile
					</v-btn>
				</v-col>
			</v-row>
		</v-card>
		<v-card>
			<v-card-title>Password reset</v-card-title>
			<v-card-text>
				<v-form ref="form">
					<v-row>
						<v-col>
							<v-text-field
								class="pl-2"
								v-model="password.oldPassword"
								:append-icon="
									showOldPass ? 'mdi-eye' : 'mdi-eye-off'
								"
								:type="showOldPass ? 'text' : 'password'"
								:rules="[rules.required]"
								label="Old password"
							>
								<template v-slot:append>
									<v-icon
										v-if="showOldPass"
										@click="toggleOldPassVisibility"
										style="cursor: pointer"
										tabindex="-1"
									>
										mdi-eye</v-icon
									>
									<v-icon
										v-else
										@click="toggleOldPassVisibility"
										style="cursor: pointer"
										tabindex="-1"
									>
										mdi-eye-off</v-icon
									>
								</template></v-text-field
							>
						</v-col>
						<v-col>
							<v-text-field
								:append-icon="
									showNewPass ? 'mdi-eye' : 'mdi-eye-off'
								"
								:type="showNewPass ? 'text' : 'password'"
								:rules="passRules"
								v-model="password.newPassword"
								label="New password"
							>
								<template v-slot:append>
									<v-icon
										v-if="showNewPass"
										@click="toggleNewPassVisibility"
										style="cursor: pointer"
										tabindex="-1"
									>
										mdi-eye</v-icon
									>
									<v-icon
										v-else
										@click="toggleNewPassVisibility"
										style="cursor: pointer"
										tabindex="-1"
									>
										mdi-eye-off</v-icon
									>
								</template>
							</v-text-field>
							<password-meter :password="password.newPassword" />
						</v-col>

						<v-col>
							<v-text-field
								:type="showConfPass ? 'text' : 'password'"
								:rules="confirmPassRules"
								v-model="password.confirmPassword"
								label="Confirm new password"
								@keydown.enter="onSave"
							>
								<template v-slot:append>
									<v-icon
										v-if="showConfPass"
										@click="toggleConfPassVisibility"
										style="cursor: pointer"
										tabindex="-1"
									>
										mdi-eye</v-icon
									>
									<v-icon
										v-else
										@click="toggleConfPassVisibility"
										style="cursor: pointer"
										tabindex="-1"
									>
										mdi-eye-off</v-icon
									>
								</template>
							</v-text-field>
							<password-meter
								:password="password.confirmPassword"
							/>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-btn text outlined @click="onReset">
					<v-icon class="mr-1">mdi-refresh</v-icon>Reset
				</v-btn>
				<v-spacer />

				<v-btn color="primary" @click="onSave">
					<v-icon class="mr-1">mdi-content-save</v-icon>Save
				</v-btn>
			</v-card-actions>
		</v-card>
		<v-spacer />
		<v-container fluid class="mt-2">
			<v-row>
				<v-spacer />
				<v-btn text outlined @click="onCancel"> Back </v-btn>
			</v-row>
		</v-container>
	</div>
</template>
<script>
import passwordMeter from 'vue-simple-password-meter';
import { ProfileActions } from '../../store/actions';
import { mapGetters } from 'vuex';
import {
	ProjectContextGetters,
	ClientContextGetters,
} from '../../store/getters';
import QrcodeVue from 'qrcode.vue';
import vueAppSubfolder from '../../utils/appSubfolderUtils';

export default {
	name: 'MyProfile',
	components: { passwordMeter, QrcodeVue },
	data() {
		return {
			value: 'https://example.com',
			size: 300,
			showNewPass: false,
			showConfPass: false,
			showOldPass: false,
			password: {
				oldPassword: '',
				newPassword: '',
				confirmPassword: '',
			},
			rules: {
				required: (value) => !!value || 'Field is required',
				email: (value) => {
					const pattern =
						/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					return pattern.test(value) || 'Invalid email format';
				},
				passwordMatch: (v) =>
					v === this.password.newPassword || 'Password must match!',
				passwordLength: (v) => {
					if (v)
						return (
							v.length >= 8 ||
							'Password must be at least eight characters long'
						);
					return 'Password must be at least eight characters long';
				},
				passwordContainsNumber: (v) =>
					/\d/.test(v) || 'Password must contain at least one number',
				passwordHasLowerCase: (v) =>
					String(v).toUpperCase() != v ||
					'Password must contain at least one lower-case letter',
				passwordHasUpperCase: (v) =>
					String(v).toLowerCase() != v ||
					'Password must contain at least one upper-case letter',
				passwordContainsSpecialCharacter: (v) => {
					const pattern = /[!@#$%&=]+/;
					return (
						pattern.test(v) ||
						'Password must contain at least one special character (!, @, #, $, %, &, =)'
					);
				},
			},
		};
	},
	computed: {
		...mapGetters({
			selectedProject: [ProjectContextGetters.SELECTED_PROJECT],
			selectedClient: [ClientContextGetters.SELECTED_CLIENT],
		}),
		apkFileUrl() {
			let prefix = '';
			if (vueAppSubfolder.get() && vueAppSubfolder.get() != '/')
				prefix = vueAppSubfolder.get();
			return (
				prefix + '/MobileApp/com.assetinventories.irismobileclient.apk'
			);
		},
		projectURL() {
			if (!this.selectedClient) return null;
			let param = this.selectedClient.Host;
			if (vueAppSubfolder.get() && vueAppSubfolder.get() != '/')
				param = param + vueAppSubfolder.get();
			return `https://${param}`;
		},
		qrString() {
			if (!this.qr) return '';
			return JSON.stringify(this.qr);
		},
		qr() {
			if (!this.selectedClient) return null;
			if (!this.selectedProject) return null;
			if (!this.projectURL) return null;
			return {
				WebsiteUrl: this.projectURL,
				ProjectId: this.selectedProject.Id,
				ProjectName: this.selectedProject.Name,
				ProjectDescription: this.selectedProject.Description,
			};
		},

		passRules() {
			let rules = [
				this.rules.required,
				this.rules.passwordLength,
				this.rules.passwordContainsNumber,
				this.rules.passwordContainsSpecialCharacter,
				this.rules.passwordHasLowerCase,
				this.rules.passwordHasUpperCase,
			];
			return rules;
		},
		confirmPassRules() {
			let rules = [];
			if (this.passRules.length > 0)
				rules.push(this.rules.required, this.rules.passwordMatch);
			return rules;
		},
	},
	methods: {
		toggleNewPassVisibility() {
			this.showNewPass = !this.showNewPass;
		},
		toggleConfPassVisibility() {
			this.showConfPass = !this.showConfPass;
		},
		toggleOldPassVisibility() {
			this.showOldPass = !this.showOldPass;
		},
		onSave() {
			if (this.$refs.form.validate()) {
				this.$store
					.dispatch(ProfileActions.CHANGE_PASSWORD, this.password)
					.then(() => this.$router.push({ name: 'Homepage' }));
			}
		},
		onReset() {
			this.$refs.form.reset();
		},
		onCancel() {
			this.$router.push({ name: 'Homepage' });
		},
	},
};
</script>
